<template>
  <div class="Details">
    <!-- EVENT & RESOURCE -->
    <div class="event">
      <div class="swiperVert">
        <swiper :options="swiperOption"> 
          <div class="swiper-slide">
            <img src="../../static/index/s1.png" alt="">
            <p>AWE 2023-Barcelona, Spain</p>
          </div>
          <div class="swiper-slide">
            <img src="../../static/index/s2.png" alt="">
            <p>AWA 2023-Bangkok, Thailand</p>
          </div>
          <div class="swiper-slide">
            <img src="../../static/index/s3.png" alt="">
            <p>Telemedia 2019-Marbella, Spain</p>
          </div>
          <div class="swiper-slide">
            <img src="../../static/index/s4.png" alt="">
            <p>TES 2019-Prague, Czech Republic</p>
          </div>
          <!-- 分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- linkedlin -->
    <div class="link">
      <div>
        <img src="../../static/details/1.png" alt="">
        <span class="transformBtn" @click="goOutLink(0)">Learn More...</span>
      </div>
      <div>
        <img src="../../static/details/2.png" alt="">
        <span class="transformBtn" @click="goOutLink(1)">Learn More...</span>
      </div>
      <div>
        <img src="../../static/details/3.png" alt="">
        <span class="transformBtn" @click="goOutLink(2)">Learn More...</span>
      </div>
    </div>
    <div class="positionBox" id="RESOURCE"></div>
    <div class="positionBox two" id="EVENT"></div>
  </div>
</template>
<script>
  import bus from '../../utils/bus';
  export default {
    name: 'Details',
    data () {
      return {
        // swiper 参数
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          grabCursor:true,
          loop: true,
          preventClicks : true,
           //自动播放
          autoplay: {
            delay: 3000, //延迟播放下一张图片
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
            // type:'custom',
            // renderCustom: function (swiper, current, total) {
            //   if(current === 1){
            //     return '<span class="swiperOne"><li><span></span></li><span class="swiperOneSpan"></span><span></span></span>';
            //   }else if(current === 2){
            //     return `<span class="swiperTwo"><span></span><li><span></span></li><span></span></span>`;
            //   }else{
            //     return `<span class="swiperThree"><span></span><span class="swiperThreeSpan"></span><li><span></span></li></span>`;
            //   }
            // }
          },
        },
        screenWidth:'',
      }
    },
    created(){
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    computed:{
      controlEventBus(){
        return this.$store.state.controlEventBus;
      }
    },
    mounted() {
      //获取屏幕尺寸
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        //屏幕尺寸变化
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    watch:{
      controlEventBus:{
        handler(val){
          if(val){
            this.goVital(val);
          }
        },
        immediate: true
      },
      screenWidth: function (n) {
        if (n <= 500) {
          this.$router.push({
            path: "detailWap",
          });
        }
      },
    },
    methods:{
      goVital(e){
        console.log(e);
        setTimeout(() => {
          document.querySelector(e).scrollIntoView({
            behavior: "auto",
          })
        }, 100);
      },
      goOutLink(e){
        if(e == 0){
          window.open('https://www.linkedin.com/pulse/new-openpin-api-vertads%3FtrackingId=m2deRUCiv9qCZNrzEMPR5g%253D%253D/?trackingId=m2deRUCiv9qCZNrzEMPR5g%3D%3D');
        }else if(e == 1){
          window.open('https://www.linkedin.com/pulse/industry-knowledge-sharing-the-promising-dcb-market%3FtrackingId=RrPvYzyz8w%252F88Apwx5lZbA%253D%253D/?trackingId=RrPvYzyz8w%2F88Apwx5lZbA%3D%3D');
        }else{
          window.open('https://www.linkedin.com/pulse/new-discussion-2023-dcb-market-nova-media-tech-limited%3FtrackingId=HsVm62oyB6BcIgDdRSl%252FmQ%253D%253D/?trackingId=HsVm62oyB6BcIgDdRSl%2FmQ%3D%3D')
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .Details{
    width: 100%;
    box-sizing: border-box;
    padding: 170px 0;
    position: relative;
    .event{
      width: 65%;
      margin: 0 auto;
      .swiperVert{
        width: 100%;
        /deep/ .swiper-container{
          position: relative;
          .swiper-slide{
            img{
              width: 100%;
              height: 670px;
              object-fit: cover;
            }
            p{
              position: absolute;
              bottom: -10px;
              left: 0;
              width: 100%;
              height: 52px;
              background: rgba(0, 0, 0, 0.38);
              text-align: center;
              line-height: 52px;
              color: #fff;
              font-size: 16px;
            }
          }
          .swiper-pagination{
            .swiper-pagination-bullet-active{
              background-color: #e1352a;
            }
          }
        }
      }
    }
    .link{
      width: 65%;
      margin: 350px auto 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-shadow:0px 0px 10px 0px rgba(112, 112, 112, 0.1);
        transition: 0.3s;
        img{
          width: 360px;
          height: auto;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        span{
          width: 190px;
          height: 50px;
          color: #DB1F27;
          border: 1px solid #DB1F27;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 80px 0;
          cursor: pointer;
        }
        span:hover{
          background: linear-gradient(to left, #E11F27 0%, #AE2025 100%,);
          color: #fff;
        }
      }
      div:hover{
        border: 2px solid #DB1F27;
        border-radius: 8px;
        transform: scale(1.03);
      }
    }
    .positionBox{
      position: absolute;
      top: 1%;
      width: 100px;
      height: 30px;
      background-color: #AE2025;
      opacity: 0;
    }
    .two{
      top: 45%;
    }
  }
  // 设置swiper分页器盒子的样式
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    width: auto;
    bottom: 20px;
    border-radius: 0% !important;
  }
  // 设置swiper分页器按钮的样式
  /deep/ .swiper-pagination-bullet{
    width: 12px;
    height: 12px;
    border-radius: 0;
    background-color: #fff;
    opacity: 1;
  }
</style>